<template>
  <div class="step-form">
    <input
      v-if="showInput"
      v-focus
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <div class="button-list">
      <button
        v-if="showClear"
        :disabled="!modelValue || uiState.isFailed || uiState.isLoading"
        @click="$emit('clear')"
      >
        清空
      </button>
      <button
        v-if="showNext"
        :disabled="!modelValue || uiState.isFailed || uiState.isLoading"
        @click="$emit('next')"
      >
        下一步
      </button>
      <button
        v-if="uiState.isFailed && uiState.isRetry"
        :disabled="uiState.isLoading"
        @click="$emit('next')"
      >
        重试
      </button>
      <button @click="$emit('reset')">重置</button>
    </div>
  </div>
</template>

<script setup>
defineProps({
  modelValue: { type: String, default: "" },
  uiState: { type: Object, required: true },
  showInput: { type: Boolean, default: true },
  showClear: { type: Boolean, default: true },
  showNext: { type: Boolean, default: true },
});
defineEmits(["update:modelValue", "next", "clear", "reset", "retry"]);
</script>

<style scoped>
/* 响应式优化：输入框样式调整 */
input {
  padding: 1rem 1rem;
  width: 50%;
  border: 1px solid #dcdfe6;
  border-radius: var(--border-radius-small);
  font-size: 1.5rem;
  text-align: center;
  box-sizing: border-box;
  transition: border-color 0.2s;
}
input:focus {
  outline: none;
  border-color: #409eff;
}
</style>
